import { HighlightedPriceDisplay } from '../components/common/pricing/HighlightedPriceDisplay';
import { HERO_BANNER_CONTENT } from '../constants/pricing/PriceDisplayOverrides';
import { usePricingInfoFromApiName } from '../hooks/upgradePageHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const UpgradePageMerchCardPriceDisplay = ({
  apiName
}) => {
  const pricingInfo = usePricingInfoFromApiName(apiName);
  return /*#__PURE__*/_jsx(HighlightedPriceDisplay, {
    pricingInfo: pricingInfo,
    skuId: pricingInfo.skuId,
    useLargePrice: true,
    priceDisplayOverride: HERO_BANNER_CONTENT,
    showDiscount: true
  });
};
export default UpgradePageMerchCardPriceDisplay;